<template>
  <v-layout row justify-center>
    <v-dialog v-model="open" persistent max-width="40vw">
      <v-card>
        <v-card-title class="headline">Envoyer une relance?</v-card-title>
        <v-card-text>Selectionnez le contenu qui sera envoyé à l'étudiant</v-card-text>
        <v-card-text>
          <v-container fluid>
            <v-checkbox
              color="teal"
              v-model="selectedReminders"
              label="Changement de mot de passe"
              value="passwordChanged"
            ></v-checkbox>
            <v-checkbox
              color="teal"
              v-model="selectedReminders"
              label="Code de savoir-vivre"
              value="codeOfConductAccepted"
            ></v-checkbox>
            <v-checkbox
              color="teal"
              v-model="selectedReminders"
              label="Questionnaire AHES"
              value="ahesFormSubmitted"
            ></v-checkbox>
            <!-- <v-flex xs12>
              <v-select :items="vectors" label="Vecteur" v-model="vector" color="teal"></v-select>
            </v-flex>-->
          </v-container>
        </v-card-text>
        <v-card-text
          v-if="student"
        >En cliquant sur envoyer, une notification de relance sera envoyé à {{student.firstName}} {{student.lastName}}.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="teal darken-1" flat @click="closeModal" :disabled="sending">Annuler</v-btn>
          <v-btn
            color="teal darken-1"
            flat
            @click="sendReminder(selectedReminders, vector)"
            :disabled="sending || selectedReminders.length === 0"
          >Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: ['open', 'closeModal', 'sendReminder', 'student', 'sending'],
  data: () => ({
    selectedReminders: [],
    vectors: [
      {
        text: 'E-mail',
        value: 'email',
      },
      {
        text: 'SMS',
        value: 'sms',
      },
    ],
    vector: 'email',
  }),
  watch: {
    open: function (newValue) {
      if (newValue) {
        this.selectedReminders = [
          !this.student.ahesFormSubmitted ? 'ahesFormSubmitted' : null,
          !this.student.passwordChanged ? 'passwordChanged' : null,
          !this.student.codeOfConductAccepted ? 'codeOfConductAccepted' : null,
        ].filter((sr) => sr);
      }
    },
  },
};
</script>